export default __webpack_public_path__ + "static/media/line4.f4c7174e.svg";